// Product Image Gallery Navigation
function initProductImageGallery() {
    const mainImage = document.getElementById('ProductPhotoImg');
    const prevButton = document.getElementById('prev');
    const nextButton = document.getElementById('next');
    const thumbnailsList = document.querySelector('.thumbnails ul');
    const expandButton = document.getElementById('expand');
    
    if (!mainImage || !prevButton || !nextButton || !thumbnailsList) {
        return;
    }
    
    // Store the original featured image - this will be updated when variants change
    let originalFeaturedImage = {
        src: mainImage.src,
        alt: mainImage.alt
    };
    
    let currentIndex = -1; // Start at -1 since featured image might not be in thumbnails
    let lightboxOpen = false;
    let lightboxCurrentIndex = 0;
    
    // Function to update the original featured image (called when variant changes)
    function updateOriginalFeaturedImage(newSrc, newAlt) {
        originalFeaturedImage = {
            src: newSrc,
            alt: newAlt || ''
        };
        
        // If we're currently showing the featured image, update it immediately
        if (currentIndex === -1) {
            loadFeaturedImage();
        }
    }
    
    // Function to load the original featured image
    function loadFeaturedImage() {
        // Fade out
        mainImage.style.transition = 'opacity 0.15s ease-out';
        mainImage.style.opacity = '0';
        
        setTimeout(() => {
            // Change to original featured image
            mainImage.src = originalFeaturedImage.src;
            mainImage.alt = originalFeaturedImage.alt;
            
            // Fade in
            setTimeout(() => {
                mainImage.style.transition = 'opacity 0.15s ease-in';
                mainImage.style.opacity = '1';
                
                // Trigger custom event for other scripts
                mainImage.dispatchEvent(new CustomEvent('image:changed', {
                    detail: {
                        src: mainImage.src,
                        alt: mainImage.alt,
                        thumbnailIndex: -1
                    }
                }));
            }, 50);
        }, 150);
    }
    
    // Get all visible thumbnail items (not variant-hidden)
    function getVisibleThumbnails() {
        const allThumbnails = thumbnailsList ? Array.from(thumbnailsList.querySelectorAll('.product__media-item')) : [];
        const allLiElements = thumbnailsList ? Array.from(thumbnailsList.querySelectorAll('li')) : [];
        const visibleThumbnails = thumbnailsList ? Array.from(thumbnailsList.querySelectorAll('.product__media-item:not(.variant-hidden)')) : [];
        
        // If no .product__media-item elements found, try using all li elements
        if (allThumbnails.length === 0 && allLiElements.length > 0) {
            return allLiElements.filter(li => !li.classList.contains('variant-hidden'));
        }
        
        // If no visible thumbnails, use all thumbnails
        if (visibleThumbnails.length === 0 && allThumbnails.length > 0) {
            return allThumbnails;
        }
        
        return visibleThumbnails;
    }
    
    // Initialize - check if current main image matches any thumbnail
    function initializeGallery() {
        const visibleThumbnails = getVisibleThumbnails();
        
        // Check if we need to load variant-specific featured image on page load
        checkAndLoadVariantImage();
        
        // Try to find current image in thumbnails
        const currentMainSrc = mainImage.src;
        const matchingThumbnail = visibleThumbnails.find(thumb => {
            const thumbSrc = thumb.getAttribute('data-media-id');
            if (thumbSrc) {
                const thumbFilename = thumbSrc.split('/').pop().split('?')[0].split('.')[0];
                const mainFilename = currentMainSrc.split('/').pop().split('?')[0].split('.')[0];
                return mainFilename.includes(thumbFilename) || thumbFilename.includes(mainFilename);
            }
            return false;
        });
        
        currentIndex = matchingThumbnail ? visibleThumbnails.indexOf(matchingThumbnail) : -1;
        
        updateThumbnailStates(visibleThumbnails);
        updateNavigationButtons(visibleThumbnails);
    }
    
    // Check and load variant-specific image on page load
    function checkAndLoadVariantImage() {
        const variantScript = document.querySelector('[data-selected-variant]');
        if (!variantScript) return;
        
        try {
            const currentVariant = JSON.parse(variantScript.textContent);
            
            if (currentVariant?.featured_image?.src) {
                let variantImageSrc = currentVariant.featured_image.src;
                const variantImageAlt = currentVariant.featured_image.alt || '';
                
                // Add protocol if missing
                if (variantImageSrc.startsWith('//')) {
                    variantImageSrc = 'https:' + variantImageSrc;
                }
                
                // Remove existing size parameters and add proper size
                variantImageSrc = variantImageSrc.replace(/(_\d+x\d+|\?\w*=\d+x\d+|&\w*=\d+x\d+)/g, '');
                variantImageSrc += variantImageSrc.includes('?') ? '&width=1440' : '?width=1440';
                
                // Check if the current main image is different from the variant's featured image
                const currentMainBase = mainImage.src.split('?')[0].replace(/(_\d+x\d+)/g, '');
                const variantBase = variantImageSrc.split('?')[0].replace(/(_\d+x\d+)/g, '');
                
                if (currentMainBase !== variantBase) {
                    updateOriginalFeaturedImage(variantImageSrc, variantImageAlt);
                    setTimeout(() => loadFeaturedImage(), 100);
                } else {
                    // Still update the reference to the properly formatted URL
                    originalFeaturedImage.src = variantImageSrc;
                    originalFeaturedImage.alt = variantImageAlt;
                }
            }
        } catch (e) {
            // Silently handle parsing errors
        }
    }
    
    // Update thumbnail visual states
    function updateThumbnailStates(thumbnails) {
        thumbnails.forEach((thumb, index) => {
            thumb.classList.toggle('active-thumbnail', index === currentIndex);
        });
    }
    
    // Update navigation button visibility
    function updateNavigationButtons(thumbnails) {
        const hasMultipleImages = thumbnails.length > 1 || (thumbnails.length === 1 && currentIndex === -1);
        
        if (prevButton) prevButton.style.display = hasMultipleImages ? 'flex' : 'none';
        if (nextButton) nextButton.style.display = hasMultipleImages ? 'flex' : 'none';
    }
    
    // Load image from thumbnail with simple fade transition
    function loadImageFromThumbnail(thumbnail) {
        const newImageSrc = thumbnail.getAttribute('data-media-id');
        const newImageAlt = thumbnail.getAttribute('variant-alt');
        const thumbnailImg = thumbnail.querySelector('img');
        
        let finalSrc = newImageSrc;
        let finalAlt = newImageAlt || '';
        
        if (!finalSrc && thumbnailImg) {
            // Fallback to thumbnail image src with higher resolution
            finalSrc = thumbnailImg.src.replace(/750x750/g, '1440x1440').replace(/_750x750/g, '_1440x1440');
            finalAlt = thumbnailImg.alt || '';
        }
        
        if (!finalSrc || mainImage.src === finalSrc) return;
        
        // Fade out
        mainImage.style.transition = 'opacity 0.15s ease-out';
        mainImage.style.opacity = '0';
        
        setTimeout(() => {
            // Change the source while invisible
            mainImage.src = finalSrc;
            if (finalAlt) mainImage.alt = finalAlt;
            
            // Fade in
            setTimeout(() => {
                mainImage.style.transition = 'opacity 0.15s ease-in';
                mainImage.style.opacity = '1';
                
                // Trigger custom event for other scripts
                mainImage.dispatchEvent(new CustomEvent('image:changed', {
                    detail: {
                        src: mainImage.src,
                        alt: mainImage.alt,
                        thumbnailIndex: currentIndex
                    }
                }));
            }, 350);
        }, 350);
    }
    
    // Navigate to next image
    function navigateNext() {
        const visibleThumbnails = getVisibleThumbnails();
        
        if (visibleThumbnails.length === 0) return;
        
        if (currentIndex === -1) {
            // If we're on featured image, go to first thumbnail
            currentIndex = 0;
            loadImageFromThumbnail(visibleThumbnails[currentIndex]);
        } else if (currentIndex === visibleThumbnails.length - 1) {
            // If we're on last thumbnail, go back to featured image
            currentIndex = -1;
            loadFeaturedImage();
        } else {
            // Move to next thumbnail
            currentIndex++;
            loadImageFromThumbnail(visibleThumbnails[currentIndex]);
        }
        
        updateThumbnailStates(visibleThumbnails);
    }
    
    // Navigate to previous image
    function navigatePrev() {
        const visibleThumbnails = getVisibleThumbnails();
        
        if (visibleThumbnails.length === 0) return;
        
        if (currentIndex === -1) {
            // If we're on featured image, go to last thumbnail
            currentIndex = visibleThumbnails.length - 1;
            loadImageFromThumbnail(visibleThumbnails[currentIndex]);
        } else if (currentIndex === 0) {
            // If we're on first thumbnail, go back to featured image
            currentIndex = -1;
            loadFeaturedImage();
        } else {
            // Move to previous thumbnail
            currentIndex--;
            loadImageFromThumbnail(visibleThumbnails[currentIndex]);
        }
        
        updateThumbnailStates(visibleThumbnails);
    }
    
    // Add click handlers to thumbnails
    function addThumbnailClickHandlers() {
        const visibleThumbnails = getVisibleThumbnails();
        
        visibleThumbnails.forEach((thumbnail, index) => {
            // Only add handler if it doesn't already exist
            if (!thumbnail.hasAttribute('data-gallery-handler')) {
                thumbnail.setAttribute('data-gallery-handler', 'true');
                
                thumbnail.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    currentIndex = index;
                    loadImageFromThumbnail(thumbnail);
                    updateThumbnailStates(getVisibleThumbnails());
                });
            }
        });
    }
    
    // Handle variant changes
    function handleVariantChange(event) {
        const variantData = event.detail?.data || event.data;
        if (!variantData) return;
        
        // Get the new variant information - check nested data structure
        let variant = variantData.variant;
        
        // If variant is not directly available, try nested data
        if (!variant && variantData.data) {
            variant = variantData.data.variant;
        }
        
        if (!variant) return;
        
        // Get the featured image from the variant
        let newFeaturedSrc = null;
        let newFeaturedAlt = null;
        
        if (variant.featured_image?.src) {
            newFeaturedSrc = variant.featured_image.src;
            newFeaturedAlt = variant.featured_image.alt || '';
        } else if (variant.featured_media?.preview_image) {
            newFeaturedSrc = variant.featured_media.preview_image.src;
            newFeaturedAlt = variant.featured_media.alt || '';
        } else if (variant.image?.src) {
            newFeaturedSrc = variant.image.src;
            newFeaturedAlt = variant.image.alt || '';
        }
        
        if (newFeaturedSrc) {
            // Add protocol if missing
            if (newFeaturedSrc.startsWith('//')) {
                newFeaturedSrc = 'https:' + newFeaturedSrc;
            }
            
            // Remove existing size parameters and add proper size
            newFeaturedSrc = newFeaturedSrc.replace(/(_\d+x\d+|\?\w*=\d+x\d+|&\w*=\d+x\d+)/g, '');
            newFeaturedSrc += newFeaturedSrc.includes('?') ? '&width=1440' : '?width=1440';
            
            // Update the original featured image reference
            updateOriginalFeaturedImage(newFeaturedSrc, newFeaturedAlt);
        }
        
        // Reset to show the featured image when variant changes
        currentIndex = -1;
        
        // Force load the featured image immediately after variant change
        if (newFeaturedSrc) {
            setTimeout(() => loadFeaturedImage(), 50);
        }
        
        // Re-initialize the gallery to handle thumbnail visibility changes
        setTimeout(() => {
            initializeGallery();
            addThumbnailClickHandlers();
            
            // Make sure we're showing the featured image
            if (currentIndex !== -1) {
                currentIndex = -1;
                updateThumbnailStates(getVisibleThumbnails());
            }
        }, 100);
    }
    
    // Mobile touch navigation functionality
    function setupMobileTouch() {
        const featuredImageContainer = document.querySelector('.product-image-featured');
        if (!featuredImageContainer) return;

        let startX = 0;
        let startY = 0;
        let startTime = 0;
        let isTracking = false;
        let hasMoved = false;
        
        const minSwipeDistance = 50; // Minimum distance for swipe
        const maxSwipeTime = 300; // Maximum time for swipe (ms)
        const tapTimeout = 200; // Maximum time for tap (ms)
        
        // Touch start handler
        function handleTouchStart(e) {
            const touch = e.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            startTime = Date.now();
            isTracking = true;
            hasMoved = false;
        }
        
        // Touch move handler
        function handleTouchMove(e) {
            if (!isTracking) return;
            
            const touch = e.touches[0];
            const deltaX = Math.abs(touch.clientX - startX);
            const deltaY = Math.abs(touch.clientY - startY);
            
            // If we've moved more than 10px, consider it movement
            if (deltaX > 10 || deltaY > 10) {
                hasMoved = true;
            }
            
            // If horizontal movement is greater than vertical, prevent default to avoid scrolling
            if (deltaX > deltaY && deltaX > 20) {
                e.preventDefault();
            }
        }
        
        // Touch end handler
        function handleTouchEnd(e) {
            if (!isTracking) return;
            
            const touch = e.changedTouches[0];
            const endX = touch.clientX;
            const endY = touch.clientY;
            const endTime = Date.now();
            
            const deltaX = endX - startX;
            const deltaY = endY - startY;
            const deltaTime = endTime - startTime;
            
            const distanceX = Math.abs(deltaX);
            const distanceY = Math.abs(deltaY);
            
            isTracking = false;
            
            // Check for tap (short duration, minimal movement)
            if (!hasMoved && deltaTime < tapTimeout) {
                handleTap(startX, featuredImageContainer);
                return;
            }
            
            // Check for swipe (horizontal movement greater than vertical, within time limit)
            if (distanceX > minSwipeDistance && 
                distanceX > distanceY && 
                deltaTime < maxSwipeTime) {
                
                if (deltaX > 0) {
                    // Swipe right - go to previous image
                    navigatePrev();
                } else {
                    // Swipe left - go to next image
                    navigateNext();
                }
            }
        }
        
        // Handle tap navigation (left side = prev, right side = next)
        function handleTap(tapX, container) {
            const containerRect = container.getBoundingClientRect();
            const containerWidth = containerRect.width;
            const relativeX = tapX - containerRect.left;
            
            // Divide container into left and right halves
            if (relativeX < containerWidth / 2) {
                // Tapped left side - go to previous image
                navigatePrev();
            } else {
                // Tapped right side - go to next image
                navigateNext();
            }
        }
        
        // Add touch event listeners only on touch devices
        if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
            featuredImageContainer.addEventListener('touchstart', handleTouchStart, { passive: false });
            featuredImageContainer.addEventListener('touchmove', handleTouchMove, { passive: false });
            featuredImageContainer.addEventListener('touchend', handleTouchEnd, { passive: true });
            
            // Prevent context menu on long press
            featuredImageContainer.addEventListener('contextmenu', (e) => {
                e.preventDefault();
            });
            
            // Add visual feedback for touch areas
            featuredImageContainer.style.cursor = 'pointer';
            featuredImageContainer.style.userSelect = 'none';
        }
    }

    // Mouse navigation for desktop (optional enhancement)
    function setupMouseNavigation() {
        const featuredImageContainer = document.querySelector('.product-image-featured');
        if (!featuredImageContainer) return;
        
        // Only add mouse navigation on non-touch devices
        if (!('ontouchstart' in window) && navigator.maxTouchPoints === 0) {
            featuredImageContainer.addEventListener('click', (e) => {
                const containerRect = featuredImageContainer.getBoundingClientRect();
                const containerWidth = containerRect.width;
                const relativeX = e.clientX - containerRect.left;
                
                // Don't interfere with expand button clicks
                const expandButton = document.getElementById('expand');
                if (expandButton && expandButton.contains(e.target)) {
                    return;
                }
                
                // Don't interfere with existing navigation button clicks
                if (e.target.closest('#prev') || e.target.closest('#next')) {
                    return;
                }
                
                // Divide container into left and right halves
                if (relativeX < containerWidth / 2) {
                    navigatePrev();
                } else {
                    navigateNext();
                }
            });
        }
    }
    
    // Setup all event listeners
    function setupEventListeners() {
        // Navigation buttons
        prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            navigatePrev();
        });
        
        nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            navigateNext();
        });
        
        // Thumbnail clicks
        addThumbnailClickHandlers();
        
        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
            if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
                if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    navigatePrev();
                } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    navigateNext();
                } else if (e.key === 'Escape') {
                    closeLightbox();
                }
            }
        });
        
        // Expand button
        if (expandButton) {
            expandButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                openLightbox();
            });
        }
        
        // Listen for variant changes
        document.addEventListener('variant:change', handleVariantChange);
        
        // Subscribe to PUB_SUB variant changes
        if (typeof subscribe === 'function') {
            subscribe('variant-change', ({ data }) => {
                handleVariantChange({ detail: { data } });
            });
        }
        
        // Listen for direct main image changes (fallback)
        mainImage.addEventListener('load', () => {
            if (currentIndex === -1) {
                originalFeaturedImage.src = mainImage.src;
                originalFeaturedImage.alt = mainImage.alt;
            }
        });
        
        // Setup mobile touch navigation
        setupMobileTouch();
        setupMouseNavigation();
    }
    
    // Lightbox functionality
    function createLightbox() {
        const lightbox = document.createElement('div');
        lightbox.id = 'gallery-lightbox';
        lightbox.innerHTML = `
            <div class="lightbox-overlay">
                <button class="lightbox-close" aria-label="Close lightbox">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <div class="lightbox-image-container">
                    <img class="lightbox-image" src="" alt="" />
                    <div class="lightbox-controls">
                        <button class="lightbox-prev icon" aria-label="Previous image">
                            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
                                <circle class="background" cx="23" cy="23" r="23" fill="#fff" fill-opacity=".43"/>
                                <path d="m25 14-9 8.5 9 8.5" stroke="#474950" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                        <button class="lightbox-next icon" aria-label="Next image">
                            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
                                <circle class="background" cx="23" cy="23" r="23" transform="matrix(-1 0 0 1 46 0)" fill="#fff" fill-opacity=".43"/>
                                <path d="m21 14 9 8.5-9 8.5" stroke="#474950" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                    <div class="lightbox-dots-container">
                        <div class="lightbox-dots"></div>
                    </div>
                </div>
            </div>
        `;
        
        document.body.appendChild(lightbox);
        return lightbox;
    }
    
    function getAllLightboxImages() {
        const allImages = [{
            src: originalFeaturedImage.src,
            alt: originalFeaturedImage.alt,
            isFeatured: true
        }];
        
        // Add all visible thumbnails
        const visibleThumbnails = getVisibleThumbnails();
        visibleThumbnails.forEach(thumbnail => {
            const src = thumbnail.getAttribute('data-media-id');
            const alt = thumbnail.getAttribute('variant-alt');
            const thumbnailImg = thumbnail.querySelector('img');
            
            let finalSrc = src;
            let finalAlt = alt || '';
            
            if (!finalSrc && thumbnailImg) {
                finalSrc = thumbnailImg.src.replace(/750x750/g, '1440x1440').replace(/_750x750/g, '_1440x1440');
                finalAlt = thumbnailImg.alt || '';
            }
            
            if (finalSrc) {
                allImages.push({
                    src: finalSrc,
                    alt: finalAlt,
                    isFeatured: false,
                    thumbnailElement: thumbnail
                });
            }
        });
        
        return allImages;
    }
    
    function openLightbox() {
        if (lightboxOpen) return;
        
        const allImages = getAllLightboxImages();
        if (allImages.length === 0) return;
        
        // Determine which image to show in lightbox
        lightboxCurrentIndex = currentIndex === -1 ? 0 : currentIndex + 1;
        
        const lightbox = document.getElementById('gallery-lightbox') || createLightbox();
        lightboxOpen = true;
        
        // Prevent body scroll
        document.body.style.overflow = 'hidden';
        
        // Setup lightbox event listeners
        setupLightboxEventListeners(lightbox);
        
        // Create dots for navigation
        createLightboxDots(allImages, lightbox);
        
        // Show initial image
        updateLightboxImage(allImages, lightbox);
        
        // Show lightbox with animation
        lightbox.style.display = 'flex';
        setTimeout(() => lightbox.classList.add('active'), 10);
    }
    
    function closeLightbox() {
        if (!lightboxOpen) return;
        
        const lightbox = document.getElementById('gallery-lightbox');
        if (lightbox) {
            lightbox.classList.remove('active');
            setTimeout(() => {
                lightbox.style.display = 'none';
                document.body.style.overflow = '';
                lightboxOpen = false;
            }, 300);
        }
    }
    
    function setupLightboxEventListeners(lightbox) {
        const closeBtn = lightbox.querySelector('.lightbox-close');
        const prevBtn = lightbox.querySelector('.lightbox-prev');
        const nextBtn = lightbox.querySelector('.lightbox-next');
        const overlay = lightbox.querySelector('.lightbox-overlay');
        
        closeBtn.addEventListener('click', closeLightbox);
        
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) closeLightbox();
        });
        
        prevBtn.addEventListener('click', () => navigateLightbox(-1));
        nextBtn.addEventListener('click', () => navigateLightbox(1));
    }
    
    function createLightboxDots(allImages, lightbox) {
        const dotsContainer = lightbox.querySelector('.lightbox-dots');
        dotsContainer.innerHTML = '';
        
        allImages.forEach((_, index) => {
            const dot = document.createElement('button');
            dot.className = 'lightbox-dot';
            dot.setAttribute('aria-label', `Go to image ${index + 1}`);
            dot.addEventListener('click', () => {
                lightboxCurrentIndex = index;
                updateLightboxImage(allImages, lightbox);
                updateLightboxDots(lightbox);
                updateMainGalleryFromLightbox(allImages, index);
            });
            dotsContainer.appendChild(dot);
        });
        
        updateLightboxDots(lightbox);
    }
    
    function updateLightboxDots(lightbox) {
        const dots = lightbox.querySelectorAll('.lightbox-dot');
        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === lightboxCurrentIndex);
        });
    }
    
    function updateLightboxImage(allImages, lightbox) {
        const lightboxImage = lightbox.querySelector('.lightbox-image');
        const imageData = allImages[lightboxCurrentIndex];
        
        if (!imageData) return;
        
        lightboxImage.src = imageData.src;
        lightboxImage.alt = imageData.alt;
        
        updateLightboxDots(lightbox);
    }
    
    function navigateLightbox(direction) {
        if (!lightboxOpen) return;
        
        const allImages = getAllLightboxImages();
        const lightbox = document.getElementById('gallery-lightbox');
        
        if (direction === 1) {
            lightboxCurrentIndex = (lightboxCurrentIndex + 1) % allImages.length;
        } else {
            lightboxCurrentIndex = lightboxCurrentIndex === 0 ? allImages.length - 1 : lightboxCurrentIndex - 1;
        }
        
        updateLightboxImage(allImages, lightbox);
        updateMainGalleryFromLightbox(allImages, lightboxCurrentIndex);
    }
    
    function updateMainGalleryFromLightbox(allImages, index) {
        const imageData = allImages[index];
        
        if (imageData.isFeatured) {
            // Switch back to featured image
            currentIndex = -1;
            loadFeaturedImage();
            updateThumbnailStates(getVisibleThumbnails());
        } else if (imageData.thumbnailElement) {
            // Find the thumbnail index in the visible thumbnails array
            const visibleThumbnails = getVisibleThumbnails();
            const thumbnailIndex = visibleThumbnails.indexOf(imageData.thumbnailElement);
            
            if (thumbnailIndex >= 0) {
                currentIndex = thumbnailIndex;
                loadImageFromThumbnail(imageData.thumbnailElement);
                updateThumbnailStates(visibleThumbnails);
            }
        }
    }
    
    // Initialize everything
    setupEventListeners();
    initializeGallery();
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(initProductImageGallery, 200);
    });
} else {
    setTimeout(initProductImageGallery, 200);
}

// Also try to initialize after a longer delay in case other scripts are interfering
setTimeout(() => {
    if (!document.querySelector('[data-gallery-handler]')) {
        initProductImageGallery();
    }
}, 1000);